import './ReleaseNotes.scss';

type Props = {
  closeModal: () => void;
  showReleaseNotes: boolean;
};
const ReleaseNotes = ({ closeModal, showReleaseNotes }: Props) => {
  if (true) {
    return null;
  }
  return (
    <div className="release-notes-modal-overlay">
      <div className="release-notes-modal">
        <p className="release-notes-modal-title">April 2025 (version 1.0.1)</p>

        <p className="release-notes-modal-close" onClick={() => closeModal()}>
          X
        </p>
      </div>
    </div>
  );
};

export default ReleaseNotes;
// tese
